import { api } from "./api";
import { fetchRule } from "./rule.service";
import { getTutorial } from "./tutorial.service";
import { ControlDate } from "../types/controle-datas";
import { dedupedFetch } from "./cache";

const fetchDates = async() =>{
    return dedupedFetch("cronograma", async () => {
        const {data} = await api.get('/database/cronograma__c')

        if(!Array.isArray(data)){
            return [];
        }else{
            return data;
        }
    }, 120_000);
}

const fetchControlDates = async(): Promise<ControlDate[]> => {
    return dedupedFetch("control-dates", async () => {
        const { data } = await api.get('/database/controle_datas__c');

        if (!Array.isArray(data)) {
            return [];
        } else {
            return data;
        }
    }, 120_000);
}

const GeneralItens = async(existingControlDates?: ControlDate[]) =>{
    try{
        const hasControlDates = existingControlDates && existingControlDates.length > 0;
        const [dates, fetchedControlDates, rules, tutorial] = await Promise.all([
            fetchDates(),
            hasControlDates ? Promise.resolve(existingControlDates) : fetchControlDates(),
            fetchRule(),
            getTutorial('6787e5fde510835c7932dba3')
        ])

        return {dates, controlDates: fetchedControlDates, rules, tutorial};

    }catch(e){
        throw e;
    }
}

export default GeneralItens;
export { fetchControlDates };